import React, {useCallback, useContext, useEffect, useImperativeHandle, useRef} from 'react';
import styles from './number-picker.module.css';
import ArrowMax from '../../../assets/images/arrow_max.png';
import ArrowMin from '../../../assets/images/arrow_min.png';
import ArrowUp from '../../../assets/images/arrow_up.png';
import ArrowDown from '../../../assets/images/arrow_down.png';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';

function NumberPicker({caption, inputRef, max, min = 0, ...props}) {
  const upPress = useKeyPress('ArrowUp');
  const downPress = useKeyPress('ArrowDown');
  const ref = useRef();
  const {onUpdateCommands} = useContext(CommandsContext);
  useImperativeHandle(inputRef, () => ref.current);
  const {
    aocContent,
    aocWindowLeft,
    aocWindowLeftTop,
    aocWindowLeftBottom,
    aocWindowRight,
    arrowMax,
    numberMax,
    arrowMin,
    numberMin,
    arrowUp,
    arrowDown,
    numPicker,
    rightTop,
    rightBottom,
    aocWindowTop,
  } = styles;

  const onUp = useCallback(() => {
    if (parseInt(ref.current.value) === max) return;
    ref.current.value = parseInt(ref.current.value) + 1;
  }, [ref]);

  const onDown = useCallback(() => {
    if (parseInt(ref.current.value) === min) return;
    ref.current.value = parseInt(ref.current.value) - 1;
  }, [ref]);

  useEffect(() => {
    if (!upPress) return;
    onUp();
  }, [upPress, onUp]);

  useEffect(() => {
    if (!downPress) return;
    onDown();
  }, [downPress, onDown]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands(commands => ({...commands, onUp, onDown}));
    });
  }, [onUp, onDown]);

  return (
    <div className={aocContent}>
      <div className={aocWindowTop}>{caption}</div>
      <div className={aocWindowLeft}>
        <div className={aocWindowLeftTop}>
          <span className={numberMax}>10</span>
          <img className={arrowMax} src={ArrowMax} alt="Max" />
        </div>
        <div className={aocWindowLeftBottom}>
          <span className={numberMin}>0</span>
          <img className={arrowMin} src={ArrowMin} alt="Min" />
        </div>
      </div>
      <div className={aocWindowRight}>
        <div className={rightTop}>
          <img className={arrowUp} src={ArrowUp} alt="Up" />
        </div>
        <input
          type="number"
          className={numPicker}
          autoFocus
          max={max}
          onKeyDown={e => e.preventDefault()}
          min={min}
          ref={ref}
          {...props}
        />
        <div className={rightBottom}>
          <img className={arrowDown} src={ArrowDown} alt="Down" />
        </div>
      </div>
    </div>
  );
}

export default NumberPicker;
